import type { CSSProperties } from "react";
import { gameStatusGradeColor } from "features/datagrid-configs/discoverGames";

interface GameHistoryStatusBadgeProps {
	statusValue: string | null | undefined;
	label: string;
}

export function GameHistoryStatusBadge({ statusValue, label }: GameHistoryStatusBadgeProps) {
	const color = gameStatusGradeColor(statusValue);
	const style: CSSProperties | undefined = color
		? ({ ["--dgs-game-status-color" as string]: color } as CSSProperties)
		: undefined;

	return (
		<span
			className="discoverGameHistory-statusBadge"
			style={style}
			data-status={statusValue ?? ""}
		>
			{label}
		</span>
	);
}
